import { shortenAddress } from '../lib/utils';

interface Holder {
  address: string;
  percentage: number;
  isCreator?: boolean;
  isBundled?: boolean;
}

interface Props {
  holders: Holder[];
  maxDisplay?: number;
}

export function HolderChart({ holders, maxDisplay = 5 }: Props) {
  const displayHolders = holders.slice(0, maxDisplay);
  const maxPercent = Math.max(...displayHolders.map((h) => h.percentage), 1);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {displayHolders.map((holder, i) => (
        <div key={holder.address}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '4px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{
                fontSize: '12px',
                color: 'var(--text-tertiary)',
                fontFamily: 'var(--font-mono)',
              }}>
                {shortenAddress(holder.address)}
              </span>
              {holder.isCreator && (
                <span style={{
                  padding: '2px 6px',
                  fontSize: '10px',
                  background: 'var(--accent-muted)',
                  color: 'var(--accent)',
                  borderRadius: 'var(--radius-sm)',
                }}>
                  Creator
                </span>
              )}
              {holder.isBundled && (
                <span style={{
                  padding: '2px 6px',
                  fontSize: '10px',
                  background: 'rgba(255, 107, 53, 0.15)',
                  color: 'var(--risk-high)',
                  borderRadius: 'var(--radius-sm)',
                }}>
                  Bundled
                </span>
              )}
            </div>
            <span style={{
              fontSize: '13px',
              fontWeight: 600,
              color: holder.percentage > 20 ? 'var(--risk-high)' : 'var(--text-primary)',
            }}>
              {holder.percentage.toFixed(1)}%
            </span>
          </div>
          <div style={{
            height: '6px',
            background: 'var(--bg-tertiary)',
            borderRadius: '3px',
            overflow: 'hidden',
          }}>
            <div style={{
              height: '100%',
              width: `${(holder.percentage / maxPercent) * 100}%`,
              background: getBarColor(holder, i),
              borderRadius: '3px',
              transition: 'width 0.3s ease',
            }} />
          </div>
        </div>
      ))}
    </div>
  );
}

function getBarColor(holder: Holder, index: number): string {
  if (holder.isBundled) return 'var(--risk-high)';
  if (holder.isCreator) return 'var(--accent)';
  if (holder.percentage > 30) return 'var(--risk-medium)';

  const colors = [
    'var(--accent)',
    '#8B7FD4',
    '#6B5FBB',
    '#5B4FA6',
    '#4B3F96',
  ];
  return colors[index] || colors[colors.length - 1];
}
